module.exports = __webpack_public_path__ + "media/images/red_heart-50a7799d.svg";